import React, { FC } from 'react';
import { DropdownMenuContentProps } from '@kontentino/ui';
import useDropZone from './DropZoneProvider';
import FileSourcePicker from '../FileSourcePicker';

type Props = {
  dropzoneContentProps?: DropdownMenuContentProps;
};

const DropZoneFilePicker: FC<Props> = ({ dropzoneContentProps }) => {
  const { fileSources, disabled, isDragActive } = useDropZone();
  return (
    <FileSourcePicker
      isDragActive={isDragActive}
      fileSources={fileSources}
      disabled={disabled}
      hasDropZoneWrapper
      dropzoneContentProps={dropzoneContentProps}
    />
  );
};

export default DropZoneFilePicker;
